module.exports = __webpack_public_path__ + "media/images/edion/zh/edion-tax-free-banner-501d93acb66dc5048907c12a624299e0.png";